import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { ProductDTO, ProductFamily, ProductsFilters } from '../../models/product';
import { ListResultDTO } from '../../../helpers/listResult.interface copy';
import { toFormData } from '../../../helpers/form.utils';

@Injectable({
  providedIn: "root"
})
export class LaravelProductService {
  constructor(private httpClient: HttpClient) { }

  private get ROUTES() {
    return {
      list: environment.baseUrl + "/api/products",
      show: environment.baseUrl + '/api/products',
      store: environment.baseUrl + "/api/products",
      delete: environment.baseUrl + "/api/products",
      destroy: environment.baseUrl + '/api/products'

    };
  }

  public list(
    page: number,
    per_page: number,
    order: string,
    direction: string,
    filters: ProductsFilters,
    includes?: string[]
  ): Observable<ListResultDTO<ProductDTO>> {
    let params = {};
        if (order) params['order'] = '' + order;
        if (direction) params['direction'] = '' + direction;
        if (includes) params['includes[]'] = includes;
        if (filters) {
          if (filters.search) params['search'] = filters.search;
          if(filters.type) params['type'] = filters.type;
        }
        if (per_page) {
          params['per_page'] = '' + per_page;
          if (page) params['page'] = '' + page;
          return this.httpClient.get<ListResultDTO<ProductDTO>>(
            this.ROUTES.list,
            {
              params: new HttpParams({ fromObject: params }),
            }
          );
        } else {
          return this.httpClient
            .get<ProductDTO[]>(this.ROUTES.list, {
              params: new HttpParams({ fromObject: params }),
            })
            .pipe(
              map((results) => {
                return {
                  data: results,
                  total: results.length,
                };
              })
            );
        }
  }

  public show(id: number): Observable<ProductDTO> {
    let params = { id: '' + id };
    return this.httpClient.get<ProductDTO>(this.ROUTES.show, {
      params: new HttpParams({
        fromObject: params,
      }),
    });
  }

  public create(formData: FormData) {
    return this.httpClient.post(this.ROUTES.store, formData);
  }

  public upsert(product: ProductDTO): Observable<ProductDTO> {
    if (product?.id) {
      return this.httpClient.post<ProductDTO>(`${this.ROUTES.store}/${product.id}`,
        toFormData(product, true),
      );
    } else {
      return this.httpClient.post<ProductDTO>(`${this.ROUTES.store}`,
        toFormData(product),
      );
    }
  }

  public delete(id: number): Observable<any> {
    return this.httpClient.delete(this.ROUTES.destroy + "/" + id);
  }
}
